import WizardStepPage from './WizardStepPage';

/** Step 7 — Add-ons */
const AddonsStep = (props) => (
    <WizardStepPage
        stepKey="addons"
        isStepDataLoading={props.isStepDataLoading}
        formData={props.formData?.addons}
        onChange={props.onChange}
        errors={props.errors}
        setErrors={props.setErrors}
        basePrice={props.formData?.pricing?.base_price ?? props.formData?.packages?.base_price}
        tripComponents={props.tripComponents}
        itineraryDaysList={props.itineraryDaysList}
        onNewComponent={props.onNewComponent}
        onSearchExistingComponent={props.onSearchExistingComponent}
        tripCurrency={props.tripCurrency}
    />
);

export default AddonsStep;
